"use client";

import { Building2, HardHat, Network } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const segments = [
  {
    icon: Building2,
    title: "Empresas mandantes",
    description:
      "Controlan el cumplimiento documental de sus contratistas y asumen el riesgo operativo de la subcontratación.",
    tags: ["Redes educativas", "Clínicas", "Edificios"],
  },
  {
    icon: HardHat,
    title: "Proveedores de servicios",
    description:
      "Gestionan la documentación de sus trabajadores y demuestran cumplimiento ante múltiples clientes.",
    tags: ["Aseo", "Seguridad", "Servicios"],
  },
  {
    icon: Network,
    title: "Organizaciones multi-sede",
    description:
      "Centralizan el control documental en operaciones distribuidas con mayor volumen y trazabilidad.",
    tags: ["Multi-proyecto", "Escalable", "Trazabilidad"],
  },
];

export default function MarketSegments() {
  return (
    <section
      id="segmentos"
      aria-label="Segmentos de mercado de Verify"
      className="px-6 pt-16 sm:pt-20 pb-16 sm:pb-20"
    >
      <div className="mx-auto max-w-[60rem] text-center mb-12">
        <ScrollReveal>
          <span className="inline-block rounded-full px-3.5 py-1 text-sm sm:text-base font-semibold text-accent mb-0">
            Para quién
          </span>
        </ScrollReveal>
        <ScrollReveal delay={0.08}>
          <h2 className="flex flex-col text-balance font-medium text-[2rem] sm:text-[36px] lg:text-5xl tracking-[-0.02em] text-dark-teal leading-[1.1] sm:leading-[1] mb-4">
            <span>Pensado para tu operación.</span>
            <span className="text-[#a6a6ab]">A cualquier escala.</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.15}>
          <p className="text-pretty text-[.95rem] sm:text-[18px] leading-[1.6] text-dark-teal/50 max-w-[540px] mx-auto">
            Desde empresas mandantes hasta operaciones multi-sede, Verify se adapta
            al control documental que cada equipo necesita.
          </p>
        </ScrollReveal>
      </div>

      <div className="mx-auto max-w-[60rem] grid grid-cols-1 md:grid-cols-3 gap-5">
        {segments.map(({ icon: Icon, title, description, tags }, i) => (
          <ScrollReveal key={title} delay={i * 0.1} className="h-full">
            <div className="group flex flex-col bg-white/60 backdrop-blur-md border border-white rounded-[24px] p-7 h-full transition-all duration-300 ease-[cubic-bezier(0.32,0.72,0,1)] ring-1 ring-dark-teal/[0.04] hover:ring-accent/30 hover:bg-white/80">
              <div className="w-11 h-11 flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-xl border border-white ring-1 ring-dark-teal/[0.03] mb-5 transition-all duration-300 group-hover:ring-accent/20 group-hover:bg-white">
                <Icon
                  className="w-5 h-5 text-accent"
                  strokeWidth={1.8}
                />
              </div>

              <h3 className="text-base sm:text-[17px] tracking-tight font-semibold text-dark-teal mb-2 transition-colors duration-300">
                {title}
              </h3>

              <p className="text-[14px] leading-[1.6] text-dark-teal/65 flex-grow mb-5 transition-colors duration-300 group-hover:text-dark-teal/85">
                {description}
              </p>

              <div className="flex flex-wrap gap-1.5 mt-auto">
                {tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[12px] font-medium text-accent/60 bg-white/60 px-2.5 py-1 rounded-lg border border-white/80 ring-1 ring-accent/[0.08] transition-all duration-200 group-hover:ring-accent/20 group-hover:text-accent group-hover:bg-white/80"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </section>
  );
}
